// Module 20 — the per-navigation draft drop (ORP-18864 item 2 / ORP-18859 AC 4), contributed to
// 05's `registerNavReset` exactly as module 16 contributes `registerDataExportNavResets`.
//
// SCOPE: the DRAFT only. `uploadTypes` and `executions` belong to the current {account, workspace}
// scope rather than to the page, so they survive a navigation on purpose — visiting Summary and
// coming back must not force a full refetch. `useDataConnectors`'s scope watch clears them on the
// one edge that actually invalidates them.
//
// Registered through the afterEach registry, never a beforeEach: `cancelInFlightGuard` must abort
// before anything clears (v3 `router/index.js:64-73` order, locked by `reportNavResetOrder.spec`).
//
// WHY THIS SEAM, when the wizard is an in-page mode and not a route: the draft is store state, so
// it outlives the page that built it. Nothing dropped it explicitly before — a blank wizard on the
// next visit was a side-effect of `useDataConnectors` resetting the WHOLE store on every mount,
// which holds only while `DataConnectorsPage` is the sole reader and always remounts. Module 16's
// export wizard is the identical shape and already resolves it here; solving one module's draft
// lifetime in a mount hook and the other's in the registry is what makes the seam unreadable.
import { useConnectorStore } from '../stores/connectorStore'

export type NavResetRegister = (reset: () => void) => void

/**
 * The store is resolved INSIDE the callback, not at registration time: the shell registers during
 * boot composition, and resolving a Pinia store then would bind to whatever instance was active at
 * that moment (and throw outright if none is active yet).
 */
export function registerDataConnectorNavResets(register: NavResetRegister): void {
  register(() => {
    useConnectorStore().discardDraft()
  })
}
